import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import * as $app from 'modules/app';

import { tokenReducer } from './reducers/token';
import { userEmailReducer } from './reducers/userEmail';
import { currentUserReducer } from './reducers/currentUser';
import { apiKeyUserReducer } from './reducers/apiKey';
import { selectedPublisherIdReducer } from './reducers/selectedPublisherId';
import { deviceIdReducer } from './reducers/deviceId';

const reducerBase = combineReducers({
  token: tokenReducer,
  userEmail: userEmailReducer,
  currentUser: currentUserReducer,
  apiKey: apiKeyUserReducer,
  selectedPublisherId: selectedPublisherIdReducer,
  deviceId: deviceIdReducer,
});

const reducer = (state, action) => {
  if (action.type === $app.reset().type) {
    state = undefined;
  }

  return reducerBase(state, action);
};

const persistConfig = {
  key: 'auth',
  storage: storage,
  whitelist: ['token', 'userEmail', 'currentUser', 'apiKey', 'selectedPublisherId', 'deviceId'],
};

export const authReducer = persistReducer(persistConfig, reducer);
